import dotenv from 'dotenv'
dotenv.config()

export default class Configuration {
    public static apiUrl = process.env.VUE_APP_API_URL ?? ''
    public static apiCabled = process.env.VUE_APP_API_CABLED == 'true'
    public static defaultLanguageCode = process.env.VUE_APP_DEFAULT_LANGUAGE_CODE ?? 'fr'
    public static isDev = process.env.NODE_ENV == 'development'
}
